import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

// Services
import { UiService } from 'src/app/platform/services/ui.service';
import { UserService } from 'src/app/modules/account/user.service';
import { PlatformService } from 'src/app/platform/services/platform.service';

@Component({
  selector: 'app-account-password-change',
  templateUrl: './account-password-change.component.html',
  styleUrls: ['./account-password-change.component.scss']
})
export class AccountPasswordChangeComponent implements OnInit {
  public formData: FormGroup = new FormGroup({
    passwordNew: new FormControl('', [Validators.required]),
    passwordRepeat: new FormControl('', [Validators.required, this.validatePassword()]),
    passwordCurrent: new FormControl('', [Validators.required])
  });
  public inputDataVisibility = {
    passwordNew: false,
    passwordRepeat: false,
    passwordCurrent: false
  };

  constructor(
    public dialog: MatDialogRef<AccountPasswordChangeComponent>,
    private uiService: UiService,
    private userService: UserService,
    private platformService: PlatformService,
  ) { }

  ngOnInit(): void { }

  onCancel(): void {
    this.dialog.close();
  }

  onSubmit(): void {
    if (this.formData.valid) {
      this.uiService.showSpinner(true);

      this.userService.userPassUpdate(
        this.formData.get('passwordNew')?.value,
        this.formData.get('passwordCurrent')?.value
      ).then((result) => {
        if (result.status) {
          this.dialog.close();

          this.uiService.showSpinner(false);
          this.uiService.dialogShow('Cambio de contraseña', 'Tu contraseña fue modificada correctamente.', 'success');
        }
        else {
          this.uiService.showSpinner(false);
          this.uiService.dialogShow('Cambio de contraseña', result.message, 'alert');
        }
      }, (error) => {
        this.uiService.showSpinner(false);
        this.uiService.dialogShow('Ups!', 'No es posible modificar tu contraseña en este momento. Estamos trabajando para solucionar el inconveniente.');
      });
    } else {
      this.formData.markAllAsTouched();
      this.uiService.showSnackBar('Algunos datos no están completos');
    }
  }

  formHasError(formcontrol: string, data: string): any {
    const fields: any = {
      passwordNew: {
        required:  'Ingresá una nueva contraseña'
      },
      passwordRepeat: {
        required:  'Ingresá nuevamente la contraseña elegida',
        notSame:  'Las contraseñas no son similares'
      },
      passwordCurrent: {
        required:  'Ingresá la contraseña actual de tu cuenta'
      },
    };

    return this.platformService.formHasError(this.formData, fields, formcontrol, data);
  }

  private validatePassword(): ValidatorFn {
    return (input: AbstractControl): ValidationErrors | null => {
      if (!input.root || !input.parent) {
        return null;
      }

      const root = input.root as FormGroup;

      if (root.get('passwordNew')?.value !== input.value) {
        return { notSame: true };
      }

      return null;
    };
  }
}
